import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useClientAuth } from '../contexts/ClientAuthContext';
import styled from 'styled-components';
import { GREE_1 } from '../utils/colors';

const { Title } = Typography;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, ${GREE_1} 0%, #45a049 100%);
`;

const StyledCard = styled(Card)`
  width: 400px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const StyledTitle = styled(Title)`
  text-align: center;
  color: ${GREE_1};
  margin-bottom: 24px !important;
`;

export default function ShopLogin() {
    const [loading, setLoading] = useState(false);
    const { login } = useClientAuth();
    const navigate = useNavigate();

    const onFinish = async (values) => {
        setLoading(true);
        try {
            // Simular chamada de API
            // Substitua por sua chamada real de API
            await new Promise(resolve => setTimeout(resolve, 1000));

            // Exemplo de login bem-sucedido
            const userData = {
                id: 1,
                name: 'Cliente',
                email: values.email
            };
            const token = 'fake-shop-token-' + Date.now();

            login(userData, token);
            message.success('Login realizado com sucesso!');
            navigate('/loja');
        } catch (error) {
            message.error('Erro ao fazer login. Verifique suas credenciais.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container>
            <StyledCard>
                <StyledTitle level={2}>Login - Loja</StyledTitle>
                <Form
                    name="shop_login"
                    onFinish={onFinish}
                    autoComplete="off"
                    layout="vertical"
                >
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            { required: true, message: 'Por favor, insira seu email!' },
                            { type: 'email', message: 'Email inválido!' }
                        ]}
                    >
                        <Input
                            prefix={<UserOutlined />}
                            placeholder="seu@email.com"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="Senha"
                        name="password"
                        rules={[{ required: true, message: 'Por favor, insira sua senha!' }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined />}
                            placeholder="Senha"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            block
                            size="large"
                        >
                            Entrar
                        </Button>
                    </Form.Item>
                </Form>
            </StyledCard>
        </Container>
    );
}
